<div class="tile-container" [ngStyle]="getGridListStyle" *ngIf="multistageConfig">
    <div class="tile" *ngFor="let map of multistageConfig.maps;  index as i; trackBy: trackByIdentity;" [style.minHeight.px]="'198.5'" [style.minWidth.px]="'198.5'">
        <ng-container *ngIf="isMapValorized(map); else emptyCard">
            <anatomic-map
                #anatomicMap
                [map]="map"
                [currentColor]="currentColor"
                [externalSegmentSelected]="selectedSegmentForStage(map)"
                [isMapSelected]="_isThisMapSelected(map)"
                [data]="findColorDataByStageID(map.stageID)?.colorData"
                [segmentLabel]="segmentLabelType"
                [readOnly]="readOnly"
                [hasTooltips]="true"
                [isWithViewId]="isWithViewId"
                [isWithStageName]="isWithStageName"
                [viewSideLenght]="viewsSideLenght"
                [upperLabel]="viewUpperLabelFromMap(map)"
                [lowerLabel]="viewBottomLabelFromMap(map)"
                (selectionEvent)="onSelectionEvent($event, map,i)"
                (dataUpdated)="onDataUpdated($event,map)"
            ></anatomic-map>
        </ng-container>
        <ng-template #emptyCard>
            <div class="empty-card">
                <div class="empty-map mat-elevation-z1"></div>
            </div>
        </ng-template>
    </div>
</div>
<div class="buttons-container" >
    <map-legend *ngIf="_legendButton.length > 0"
    [ngStyle]="getLegendStyle"
    [legend]="legendColors"
    [isHorizontal]="isHorizontal"
    [buttonsConfiguration]="buttonsConf"
    [actualColor]="currentColor"
    [readOnly]="readOnly"
    (colorChanged)="onLegendSelection($event)"
    (buttonClicked)="onLegendBtnClick($event)"
    >
    </map-legend>
    <ng-content extra-buttons-before select="[extra-buttons-legend]"></ng-content>
    <button *ngIf="_multistage.length > 0" class="mat-button-like copy-from-previous"
        [anatomicMapTooltip]="'copia dal precedente'"
        (click)="onCopyFromPrevious()" [disabled]="readOnly">content_copy</button>
</div>
